import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const fetchSOWs = async () => {
    const sows = await apiInputService.get("/Sow", {
        params: {
            active: true,
        },
    })
    const { data } = sows;

    return data;
}


export const useSOWsQuery = (subscription: string, options?: any) => {
    return useQuery<any[]>(["sows", subscription], () => fetchSOWs(), {
        ...options,
        
        staleTime: Infinity,
    });
}